import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const ServiceProjectItemLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[service/project-item] Load details'),
  requestFail: uniqueActionType('[service/project-item] Load details fail'),
  requestSuccess: uniqueActionType('[service/project-item] Load details success'),
  requestClearErrors: uniqueActionType('[service/project-item] Load details clear errors'),
  requestClear: uniqueActionType('[service/project-item] Load details clear')
};

export class ServiceProjectItemLoadDetailsAction implements PayloadAction {
  readonly type = ServiceProjectItemLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class ServiceProjectItemLoadDetailsFailAction implements PayloadAction {
  readonly type = ServiceProjectItemLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ServiceProjectItemLoadDetailsSuccessAction implements PayloadAction {
  readonly type = ServiceProjectItemLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ServiceProjectItemLoadDetailsClearAction implements PayloadAction {
  readonly type = ServiceProjectItemLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class ServiceProjectItemLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = ServiceProjectItemLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}
